import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Search from '@/components/index/search'
import Show from '@/components/index/show'
import Lists from '@/components/index/lists'
import Login from '@/components/user/login'
import Registered from '@/components/user/registered'
import Forget from '@/components/user/forget'
import Myfavorite from '@/components/user/myfavorite'
import Publish from '@/components/user/publish'
import Myinfo from '@/components/user/myinfo'
import Upgrade from '@/components/user/upgrade'
import Editprofile from '@/components/user/editprofile'
import Usercenter from '@/components/user/usercenter'
import Proxy from '@/components/user/proxy'
import Promote from '@/components/user/promote'
import help from '@/components/index/help'
import merchant from '@/components/index/merchant'
import merchantshow from '@/components/index/merchant_show'
import merchantjoin from '@/components/index/merchant_join'
Vue.use(Router)

export default new Router({
  routes: [
    // 首页
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/merchant',
      name: 'merchant',
      component: merchant
    },
    {
      path: '/merchantjoin',
      name: 'merchantjoin',
      meta: {
        requireAuth: true
      },
      component: merchantjoin
    },
    {
      path: '/merchantshow',
      name: 'merchantshow',
      component: merchantshow
    },
    {
      path: '/home',
      name: 'home',
      component: Index
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    // 详情信息展示页
    {
      path: '/show',
      name: 'show',
      component: Show
    },
    // 信息列表页
    {
      path: '/lists',
      name: 'lists',
      component: Lists
    },
    // 登录、注册、找回密码
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/registered',
      name: 'registered',
      component: Registered
    },
    {
      path: '/forget',
      name: 'forget',
      component: Forget
    },
    // 用户页
    {
      path: '/myfavorite',
      name: 'myfavorite',
      meta: {
        requireAuth: true
      },
      component: Myfavorite
    },
    {
      path: '/publish',
      name: 'publish',
      meta: {
        requireAuth: true
      },
      component: Publish
    },
    {
      path: '/myinfo',
      name: 'myinfo',
      meta: {
        requireAuth: true
      },
      component: Myinfo
    },
    {
      path: '/upgrade',
      name: 'upgrade',
      meta: {
        requireAuth: true
      },
      component: Upgrade
    },
    {
      path: '/editprofile',
      name: 'editprofile',
      meta: {
        requireAuth: true
      },
      component: Editprofile
    },
    {
      path: '/usercenter',
      name: 'usercenter',
      meta: {
        requireAuth: true
      },
      component: Usercenter
    },
    {
      path: '/proxy',
      name: 'proxy',
      meta: {
        requireAuth: true
      },
      component: Proxy
    },
    {
      path: '/promote',
      name: 'promote',
      meta: {
        requireAuth: true
      },
      component: Promote
    },
    { // 当没有匹配到正确路由的时候，匹配notOpen组件
      path: '*',
      component: Index
    }
  ],
  mode: 'history',
  linkActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/index.js